export const PAYMENT_GATEWAYS = [
    {id: 'cash', name: 'Cash (No Gateway)'},
    {id: 'TSYS', name: 'TSYS'},
    {id: 'OOS', name: 'Out of Scope'},
    {id: 'OOS_DATACAP', name: 'OOS Datacap'}
];


// WEBPACK FOOTER //
// ./src/Fuse/shared/paymentGateways.js